export default {
      id: "arrow-usage",
      viewBox: "0 0 49 32",
      url: "../icon/" + "icons.svg#arrow-usage",
      toString: function () {
        return this.url;
      }
    }